// DOM-specific JS should be done here
// see /boilerplate/src/js/browser.js for the import pattern

import select from 'dom-select';
import LiteYTEmbed from 'lite-youtube-embed'; // eslint-disable-line no-unused-vars
import Player from '@vimeo/player';

export const VideoLibrary = (el) => {
  const ui = {
    el,
    videos: select.all('video', el),
    youtubes: select.all('lite-youtube', el),
    vimeoIframes: select.all('iframe[src*="vimeo"]', el),
  };

  const vimeoPlayers = [];
  const YOUTUBE_PLAYING_STATE = 1;

  // Initialize Vimeo players and ensure API is enabled
  const initVimeoPlayers = () => {
    ui.vimeoIframes.forEach(iframe => {
      vimeoPlayers.push(new Player(iframe));
    });
  };

  const pauseAllExcept = (currentElement) => {
    // Pause HTML5 videos
    ui.videos.forEach(video => {
      if (video !== currentElement && !video.paused) {
        video.pause();
      }
    });

    // Pause YouTube embeds
    ui.youtubes.forEach(youtube => {
      if (youtube !== currentElement && youtube.classList.contains('lyt-activated')) {
        const iframe = select('iframe', youtube);
        if (iframe?.contentWindow) {
          iframe.contentWindow.postMessage(
            '{"event":"command","func":"pauseVideo","args":""}',
            '*'
          );
        }
      }
    });

    // Pause Vimeo embeds
    vimeoPlayers.forEach((player, index) => {
      if (ui.vimeoIframes[index] !== currentElement) {
        player.pause().catch(() => {});
      }
    });
  };

  const addEvents = () => {
    // Listen for HTML5 video play events
    ui.videos.forEach(video => {
      video.addEventListener('play', () => {
        pauseAllExcept(video);
      });
    });

    // Listen for YouTube play events via postMessage API
    window.addEventListener('message', (event) => {
      if (!event.data || typeof event.data !== 'string') return;
      
      try {
        const data = JSON.parse(event.data);
        const isPlaying = data.event === 'infoDelivery' && data.info?.playerState === YOUTUBE_PLAYING_STATE;
        
        if (isPlaying) {
          const iframe = Array.from(select.all('iframe')).find(
            frame => frame.contentWindow === event.source
          );
          
          if (iframe) {
            const youtube = iframe.closest('lite-youtube');
            if (youtube && ui.youtubes.includes(youtube)) {
              pauseAllExcept(youtube);
            }
          }
        }
      } catch (e) {}
    });

    // Initialize YouTube iframe API when lite-youtube is activated
    ui.youtubes.forEach(youtube => {
      youtube.addEventListener('liteYoutubeIframeLoaded', (e) => {
        const iframe = e.detail.iframe;
        
        // Enable event listening for YouTube iframe API
        iframe.addEventListener('load', () => {
          iframe.contentWindow.postMessage(
            '{"event":"listening","id":"' + iframe.id + '"}',
            '*'
          );
        });
      });
    });

    // Listen for Vimeo play events
    vimeoPlayers.forEach((player, index) => {
      player.on('play', () => {
        pauseAllExcept(ui.vimeoIframes[index]);
      });
    });
  };

  initVimeoPlayers();

  const init = () => {
    addEvents();
  };

  init();
};

export default VideoLibrary;
